import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box/Box';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { Form } from 'components/Form/Form';
import { FormSubmitFunction } from 'components/Form/FormContext';
import { LogoPickerField } from 'components/Form/LogoPickerField';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  org: ApiOrg;
  orgOwner: boolean;
  editMode: boolean;
  onSubmit: FormSubmitFunction<Pick<ApiOrg, 'id'> & Partial<ApiOrg>>;
};

export function ViewOrgPageSidebarImage({
  org,
  orgOwner,
  editMode,
  onSubmit,
}: Props) {
  if (orgOwner && editMode) {
    return (
      <Box mb={-24}>
        <Form
          analyticsTitle="[main] Org page - sidebar image"
          usageContext="page"
          initialValues={{
            logo: org.logo,
            id: org.id,
          }}
          onSubmit={onSubmit}
          render={({ submitForm }) => (
            <LogoPickerField
              name="logo"
              altText={org.name}
              onChange={(image) => {
                trackClicked(`Org profile: upload logo`);
                submitForm({ logo: image });
              }}
              confirmModal
              extraAnalyticsData={{
                context: 'Org Page',
                file_type: 'Org Logo',
                file_label: 'Drag a logo here',
              }}
            />
          )}
        />
      </Box>
    );
  }

  return (
    org.logo && (
      <FilestackImage
        data={org.logo}
        data-qa-id="org-logo"
        width={180}
        height={128}
        alt={sprintf(getText('Logo of %(orgName)s'), {
          orgName: org.name,
        })}
        noCrop
      />
    )
  );
}
